import { render, staticRenderFns } from "./PageEditProfile.vue?vue&type=template&id=064cd37e&scoped=true&"
import script from "./PageEditProfile.vue?vue&type=script&lang=ts&"
export * from "./PageEditProfile.vue?vue&type=script&lang=ts&"
import style0 from "./PageEditProfile.vue?vue&type=style&index=0&id=064cd37e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064cd37e",
  null
  
)

export default component.exports